var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Box, Pressable, Stack, Text } from "native-base";
const tabSizes = {
    sm: {
        tab: {
            p: 2,
        },
        text: {
            fontSize: "sm",
        },
    },
    md: {
        tab: {
            p: 2,
        },
        text: {
            fontSize: "md",
        },
    },
    lg: {
        tab: {
            p: 2,
        },
        text: {
            fontSize: "lg",
        },
    },
};
const tabVariants = {
    default: {
        badge: {
            backgroundColor: "gray.400",
            text: {
                color: "white",
            },
        },
        tab: {
            _hover: {
                borderBottomColor: "gray.200",
                borderBottomStyle: "solid",
                borderBottomWidth: 2,
            },
            py: 4,
        },
        text: {
            color: "gray.600",
        },
    },
    primary: {
        badge: {
            backgroundColor: "green.50",
            text: {
                color: "green.600",
            },
        },
        tab: {
            _hover: {
                borderBottomColor: "green.600",
                borderBottomStyle: "solid",
                borderBottomWidth: 2,
            },
        },
        text: {
            color: "green.600",
        },
    },
};
export const Tab = ({ tabState, children, setActiveTab, size = "sm", variant = "default", _tab, badge, }) => (_jsx(Pressable, Object.assign({}, tabVariants[variant].tab, tabSizes[size].tab, (tabState.active === tabState.tabIndex
    ? {
        borderBottomColor: "green.600",
        borderBottomStyle: "solid",
        borderBottomWidth: 2,
    }
    : undefined), { onPress: () => setActiveTab(tabState.tabIndex) }, _tab, { children: _jsxs(Stack, Object.assign({ direction: "row", alignItems: "center" }, { children: [_jsx(Text, Object.assign({ fontWeight: "medium" }, tabSizes[size].text, tabVariants[variant].text, { color: tabState.active === tabState.tabIndex
                    ? "green.600"
                    : tabVariants[variant].text.color }, { children: children })), badge && (_jsx(Box, Object.assign({ justifyContent: "center", alignItems: "center", minWidth: 4, height: 4, borderRadius: "full", ml: 1.5, _text: Object.assign({ fontSize: "2xs" }, tabVariants[tabState.active === tabState.tabIndex
                    ? "primary"
                    : "default"].badge.text) }, tabVariants[tabState.active === tabState.tabIndex
                ? "primary"
                : "default"].badge, { children: badge })))] })) })));
const Tabs = (_a) => {
    var { tabs, setTitle, size = "sm", variant = "default", _tab, rightContent, currentIndex = 0, chooseTab } = _a, rest = __rest(_a, ["tabs", "setTitle", "size", "variant", "_tab", "rightContent", "currentIndex", "chooseTab"]);
    const [activeTab, setActiveTab] = useState(currentIndex);
    const chooseTabIndex = (i) => {
        setActiveTab(i);
        chooseTab === null || chooseTab === void 0 ? void 0 : chooseTab(i);
    };
    useEffect(() => {
        if (!tabs.length) {
            return;
        }
        setTitle === null || setTitle === void 0 ? void 0 : setTitle(tabs[activeTab].title);
    }, [setTitle, tabs, activeTab]);
    if (!tabs.length) {
        return null;
    }
    return (_jsxs(Box, Object.assign({ testID: "tabs", flex: 1 }, { children: [_jsxs(Stack, Object.assign({ direction: "row", space: 2, width: "full", alignItems: "center" }, rest, { children: [tabs.map((tab, tabIndex) => (_jsx(Tab, Object.assign({ tabState: { tabIndex, active: activeTab }, size: size, variant: variant, setActiveTab: chooseTabIndex, _tab: _tab, badge: tab.badge }, { children: tab.title }), `tab-item-${tabIndex}`))), rightContent && _jsx(Box, Object.assign({ ml: "auto" }, { children: rightContent }))] })), _jsx(Box, { children: tabs[activeTab].content })] })));
};
export default Tabs;
